import { useEffect, useRef, useState } from 'react';

// True once the page is scrolled down past `offset` px; false again on any
// scroll up. Moves smaller than `threshold` px are ignored so finger jitter
// does not make the bar flicker.
export function useHideOnScroll(offset = 64, threshold = 8): boolean {
    const [hidden, setHidden] = useState(false);
    const last = useRef(0);

    useEffect(() => {
        last.current = window.scrollY;
        const onScroll = () => {
            const y = window.scrollY;
            const dy = y - last.current;
            if (Math.abs(dy) < threshold) return;
            setHidden(dy > 0 && y > offset);
            last.current = y;
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, [offset, threshold]);

    return hidden;
}
